









































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { TranslationsTypes } from "@/data/enums/translations";
import { RelatedProductsTypes } from "@/data/enums/products";

// Typings
import { IRelatedObject, IRelatedObjectForm } from "@/models/products";
import { IState } from "@/store";
import { IBrand } from "@/models/brands";

@Component({
  computed: {
    ...mapState({
      brandId(state: IState) {
        return state.brand.id;
      }
    })
  }
})
export default class EditRelatedObjectModal extends Mixins(HasValidation) {
  // State/Getters
  public brandId!: IBrand["id"];

  // Props
  @Prop({ required: true })
  public relatedObject!: IRelatedObject;

  // Data
  public isProcessing = false;

  public form = {} as IRelatedObjectForm;
  public formClone = {} as IRelatedObjectForm;

  public savedNameValue: IRelatedObjectForm["name"] = "";
  public savedDescriptionValue: IRelatedObjectForm["description"] = "";

  public created() {
    this.form = this.$_.mapValues(
      this.$_.pick(this.relatedObject, [
        "name",
        "description",
        "active",
        "label",
        "use_object_description"
      ]),
      value => {
        return value === null ? "" : value;
      }
    ) as IRelatedObjectForm;

    this.form.name = this.form.use_object_description
      ? this.originalName
      : this.form.name;
    this.form.description = this.form.use_object_description
      ? this.originalDescription
      : this.form.description;

    if (this.form.use_object_description) {
      this.useOriginalDescriptionChanged(this.form.use_object_description);
    }

    this.formClone = this.$_.clone(this.form);
  }

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }

      this.isProcessing = true;
      await this.updateRelatedObject();

      this.$store.dispatch("toast/show", {
        message: this.$t(`_.object_successfully_updated`, {
          object: this.$tc("_.recommendations", 1)
        })
      });

      this.$emit("success", true);
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public updateRelatedObject() {
    return this.$store.dispatch(
      `data/${DataModules.CATALOGUE}/updateRelatedObject`,
      {
        id: this.relatedObject.id,
        productId: this.relatedObject.product_id,
        data: this.newValues
      }
    );
  }

  public get originalName() {
    return this.$_.get(this.relatedObject, "related_object.name");
  }

  public get originalDescription() {
    return this.$_.get(this.relatedObject, "related_object.description");
  }

  public useOriginalDescriptionChanged(value) {
    if (value) {
      this.savedNameValue = this.form.name;
      this.form.name = this.originalName;

      this.savedDescriptionValue = this.form.description;
      this.form.description = this.originalDescription;
      return;
    }

    this.form.name = this.savedNameValue;
    this.form.description = this.savedDescriptionValue;
  }

  public get newValues() {
    const formValues = { ...this.form };
    if (formValues.use_object_description) {
      formValues.name = "";
      formValues.description = "";
    }
    return formValues;
  }

  public get formIsDisabled() {
    return (
      this.isProcessing ||
      this.$_.isEqual(this.form, this.formClone) ||
      this.hasErrors
    );
  }

  public openTranslateModal(props: Record<string, any>) {
    this.$store.dispatch(
      `data/${DataModules.TRANSLATIONS}/openTranslationsModal`,
      {
        props: {
          objectId: this.relatedObject.id,
          objectTypeCode: TranslationsTypes.PRODUCT_RELATED,
          brandId: this.brandId,
          fieldType: "text",
          ...props
        }
      }
    );
  }

  public get isProduct() {
    return this.relatedObject.object_type === RelatedProductsTypes.PRODUCT;
  }
}
